import { render } from "./PasswordsPage.vue?vue&type=template&id=7150efe1"
import script from "./PasswordsPage.vue?vue&type=script&lang=js"
export * from "./PasswordsPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/kajot/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__